module.exports = __webpack_public_path__ + "assets/car.017c3d20.svg";